import { PageId } from 'constants/pages'

export const enum PageIdWoofzVday75 {
  SUBSCRIPTIONS_VDAY_75 = PageId.SUBSCRIPTIONS_VDAY_75,
  CHAT_UPSELL_VDAY_75 = PageId.CHAT_UPSELL_VDAY_75,
  UPSELL_VDAY_75 = PageId.UPSELL_VDAY_75,
  DOWNLOAD_VDAY_75 = PageId.DOWNLOAD_VDAY_75,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
